<template>
  <!-- eslint-disable max-len -->
  <button
    class="btn"
    :disabled="disabled"
    :class="{
      primary: color === 'primary',
      destructive: color === 'destructive',
      warning: color === 'warning',
      outline,
      plain,
      small,
      hover,
      normal,
      'no-focus': noFocus,
    }"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'LegacyButton',
  props: {
    disabled: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    outline: {
      type: Boolean,
    },
    plain: {
      type: Boolean,
    },
    noFocus: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    hover: {
      type: Boolean,
    },
    normal: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/abstracts/mixins';
@import '../../styles/dorado/themes/dorado';

@mixin button-color($class, $fg, $bg) {
  &.#{$class} {
    @include bg-disabled($fg, $bg);

    &.outline {
      @include outline($bg);
    }

    &.plain {
      border: 0;
      background: transparent;
      color: $bg;
      margin: 0;
      padding: 0;
    }

    &.normal {
      font-weight: 400;
    }

    &.small {
      font-size: 12px;
      padding: 8px 16px;
    }

    &:focus {
      box-shadow: none;
    }
  }
}

/* stylelint-disable selector-no-qualifying-type */
button.btn {
  padding: 14px 30px;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  border-radius: 3px;
  cursor: pointer;
  outline: none;

  // Optional primary handle hover effects *currently still using legacy styles
  &.primary:hover {
    background-color: #0260b2;
    border-color: #025aa5;
  }

  img {
    vertical-align: middle;
  }

  /* jw: hard coding colors since they are not exposed by current vars and this comp is temporary
     note: disabling order/order since we need these to render after above for proper styling */
  /* stylelint-disable-next-line order/order */
  @include button-color(primary, #fff, #0275d8);
  @include button-color(destructive, #fff, #eb5757);
  @include button-color(warning, $dark, $primary);
}
/* stylelint-enable selector-no-qualifying-type */
</style>
